package ru.chm.gradereport.ui.components

/**
 * ISO `yyyy-MM-dd` → display `dd.MM.yyyy` (day month year).
 * Returns the input unchanged when it is not a valid ISO date.
 */
fun formatDisplayDate(isoDate: String): String {
    val trimmed = isoDate.trim()
    if (trimmed.length == 10 && trimmed[4] == '-' && trimmed[7] == '-') {
        val y = trimmed.substring(0, 4)
        val m = trimmed.substring(5, 7)
        val d = trimmed.substring(8, 10)
        if (
            y.all { it.isDigit() } && m.all { it.isDigit() } && d.all { it.isDigit() } &&
            m.toIntOrNull() in 1..12 && d.toIntOrNull() in 1..31
        ) {
            return "$d.$m.$y"
        }
    }
    return isoDate
}
